import { render, staticRenderFns } from "./KycTemplate.vue?vue&type=template&id=0e3bdfbb&scoped=true"
import script from "./KycTemplate.vue?vue&type=script&lang=js"
export * from "./KycTemplate.vue?vue&type=script&lang=js"
import style0 from "./KycTemplate.vue?vue&type=style&index=0&id=0e3bdfbb&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3bdfbb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e3bdfbb')) {
      api.createRecord('0e3bdfbb', component.options)
    } else {
      api.reload('0e3bdfbb', component.options)
    }
    module.hot.accept("./KycTemplate.vue?vue&type=template&id=0e3bdfbb&scoped=true", function () {
      api.rerender('0e3bdfbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/tasks/validaciones/constitucionsociedades/KycTemplate.vue"
export default component.exports